module.exports = __webpack_public_path__ + "img/female_introduction_2.9fe2ad07.png";